module.exports = __webpack_public_path__ + "static/media/collaborative.3b2c741a.png";